









import { Component, Vue, Prop } from "vue-property-decorator";
import VStatus from "./VStatus.vue";
import State from "@/usecases/accounting/invoice-status";
import Translator from "@/usecases/accounting/invoice-status-translater";

@Component({
  components: {
    VStatus
  }
})
export default class InvoiceStatus extends Vue {
  @Prop({ required: true }) status!: string;

  get text() {
    return Translator.toJp(this.status);
  }

  get variant() {
    return `invoice-${this.status}`;
  }

  get options() {
    return State.all().map(s => ({
      text: Translator.toJp(s),
      value: s
    }));
  }
}
